import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import { defineAsyncComponent } from 'vue'
import { message } from 'ant-design-vue';

//3.0异步组建写法
const home = defineAsyncComponent(() => import('../views/home.vue'))
const login = defineAsyncComponent(() => import('../views/login.vue'))
const Layout = defineAsyncComponent(() => import('../views/layout/layout.vue'))
//供应
const shopIndex = defineAsyncComponent(() => import("../views/shop/index.vue"));
const addShopIndex = defineAsyncComponent(() =>
    import("../views/shop/addShop.vue")
);

const shopMoney = defineAsyncComponent(() =>
    import("../views/shop/shopMoney.vue")
);
const shopAddMoney = defineAsyncComponent(() =>
    import("../views/shop/shopAddMoney.vue")
);
//渠道
const channelShopIndex = defineAsyncComponent(() =>
    import("../views/channelshop/index.vue")
);
const addChannelShopIndex = defineAsyncComponent(() =>
    import("../views/channelshop/addShop.vue")
);
const channelShopMoney = defineAsyncComponent(() =>
    import("../views/channelshop/shopMoney.vue")
);
const channelShopAddMoney = defineAsyncComponent(() =>
    import("../views/channelshop/shopAddMoney.vue")
);
const channelAccount = defineAsyncComponent(() =>
    import("../views/channelshop/channelAccount.vue")
);
//账户
const accountIndex = defineAsyncComponent(() => import('../views/account/index.vue'))
//系统管理
//用户管理
const userIndex = defineAsyncComponent(() => import('../views/sys/user/index.vue'))
//角色
const roleIndex = defineAsyncComponent(() => import('../views/sys/role/index.vue'))
//菜单
const menuIndex = defineAsyncComponent(() => import('../views/sys/menu/index.vue'))
//部门
const deptIndex = defineAsyncComponent(() => import('../views/sys/dept/index.vue'))



//新增供应业务
const addSupply = defineAsyncComponent(() => import("../views/shop/addSupply.vue"))
const newSupplyList = defineAsyncComponent(() => import("../views/shop/supplyList.vue"))
const menuList = defineAsyncComponent(() => import('../views/menu/menuList'))
const addConfig = defineAsyncComponent(() => import('../views/menu/addConfig'))
const configList = defineAsyncComponent(() => import('../views/menu/configList'))
const roleManage = defineAsyncComponent(() => import('../views/menu/roleManage'))
const newSupplyDetail = defineAsyncComponent(() => import('../views/shop/newSupplyDetail'))
const configManage = defineAsyncComponent(() => import('../views/menu/configManage'))

//测试菜单
const testMenu = defineAsyncComponent(() => import('../views/shop/testMenu'))

//积分兑换
const exchange = defineAsyncComponent(() => import("../views/order/exchange.vue"));
//积分用户查询
const scoreQuery = defineAsyncComponent(() => import('../views/order/scoreQuery.vue'))
//线下票台
const offLineTicket = defineAsyncComponent(() => import('../views/order/offLineTicket.vue'))

//车票状态列表信息
const ticketStatusList = defineAsyncComponent(() => import('../views/order/ticketStatusList.vue'))

//订单管理
const orderIndex = defineAsyncComponent(() =>
    import("../views/order/index.vue")
);
const orderDetail = defineAsyncComponent(() =>
    import("../views/order/detail.vue")
);
const supplyList = defineAsyncComponent(() =>
    import("../views/order/supply.vue")
);
//飞机票
const planeOrder = defineAsyncComponent(() =>
    import("../views/order/planeOrder.vue")
);
const planeDetail = defineAsyncComponent(() =>
    import("../views/order/planeDetail.vue")
);
//行程单打印
const orderPaint = defineAsyncComponent(() =>
    import("../views/order/orderPaint.vue")
);
//酒店订单
const hotelOrder = defineAsyncComponent(() =>
    import("../views/order/hotelOrder.vue")
);

//退票订单
const refundOrderList = defineAsyncComponent(() =>
    import("../views/order/refundOrder.vue")
);
const refundDetailIndex = defineAsyncComponent(() =>
    import("../views/order/refundDetail.vue")
);
const supplyDetailIndex = defineAsyncComponent(() =>
    import("../views/order/supplyDetail.vue")
);

//保险管理
const insuranceIndex = defineAsyncComponent(() =>
    import("../views/insurance/index.vue")
);

//财务管理

const electronicChannelFinancial = defineAsyncComponent(() =>
    import("../views/financial/electronicChannelFinancial.vue")
);
const electronicChannelDetail = defineAsyncComponent(() =>
    import("../views/financial/electronicChannelDetail.vue")
);

const channelFinancial = defineAsyncComponent(() =>
    import("../views/financial/channelFinancial.vue")
);
const channelFinancialDetail = defineAsyncComponent(() =>
    import("../views/financial/channelFinancialDetail.vue")
);
const supplyFinancial = defineAsyncComponent(() =>
    import("../views/financial/supplyFinancial.vue")
);
const supplyFinancialDetail = defineAsyncComponent(() =>
    import("../views/financial/supplyFinancialDetail.vue")
);

const policyTicketIndex = defineAsyncComponent(() =>
    import("../views/channelshop/policy/ticket.vue")
);
const policyHotelIndex = defineAsyncComponent(() =>
    import("../views/channelshop/policy/hotel.vue")
);
const policyTrainIndex = defineAsyncComponent(() =>
    import("../views/channelshop/policy/train.vue")
);
const hotelControl = defineAsyncComponent(() =>
    import("../views/channelshop/policy/hotelControl.vue")
);

//add search order
const searchOrder = defineAsyncComponent(() =>
    import("../views/searchOrder.vue")
);

const routerArr = [
    {
        path: '/',
        redirect: '/home',
        hidden: true,
    },
    {
        path: '/login',
        name: 'login',
        component: login,
        hidden: true,
    },
    {
        path: '/home',
        component: Layout,
        name: 'home',
        hidden: true,
        redirect: '/home/index',
        meta: { title: '首页', icon: 'icon-shenqing', role: ['god'] },
        children: [
            {
                path: 'index',
                name: 'homeIndex',
                component: home,
                hidden: false,
                meta: {
                    title: '首页', icon: 'icon-ceshi', role: ['god']
                }
            },
        ]
    },
    {
        path: '/shop',
        component: Layout,
        name: 'shop',
        hidden: false,
        redirect: 'shop/index',
        meta: { title: '供应管理', icon: 'icongoodsppesupplier', role: ['god'], code: 'BM' },
        children: [
            // 新增供应业务
            {
                path: 'addSupply',
                name: 'addSupply',
                component: addSupply,
                hidden: false,
                meta: {
                    title: '添加供应', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'newSupplyList',
                name: 'newSupplyList',
                component: newSupplyList,
                hidden: false,
                meta: {
                    title: '新供应列表', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                },
            },
            {
                name: "newSupplyDetail",
                path: 'newSupplyDetail',
                component: newSupplyDetail,
                meta: {
                    title: '供应详情', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                },
            },
            {
                path: 'menuList',
                name: 'menuList',
                component: menuList,
                hidden: false,
                meta: {
                    title: '菜单管理', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            }, {
                path: 'addConfig',
                name: 'addConfig',
                component: addConfig,
                hidden: false,
                meta: {
                    title: '增加配置', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'roleManage',
                name: 'roleManage',
                component: roleManage,
                hidden: false,
                meta: {
                    title: '角色管理', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'configList',
                name: 'configList',
                component: configList,
                hidden: false,
                meta: {
                    title: '增加配置', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'testMenu',
                name: 'testMenu',
                component: testMenu,
                hidden: false,
                meta: {
                    title: 'b2b测试菜单', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'configManage',
                name: 'configManage',
                component: configManage,
                hidden: false,
                meta: {
                    title: '配置管理', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            //以上为新增加业务  
            {
                path: 'index',
                name: 'shopIndex',
                component: shopIndex,
                hidden: false,
                meta: {
                    title: '供应列表', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'addShop',
                name: 'addShopIndex',
                component: addShopIndex,
                hidden: false,
                meta: {
                    title: '新增供应商', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            // {
            //     path: 'money',
            //     name: 'shopMoney',
            //     component: shopMoney,
            //     hidden: false,
            //     meta: {
            //         title: '供应资金', icon: 'iconzijinmingxi', role: ['god'],code:'BM:LIST'
            //     }
            // },
            {
                path: 'addMoney',
                name: 'shopAddMoney',
                component: shopAddMoney,
                hidden: true,
                meta: {
                    title: '供应资金充值', icon: 'icon-ceshi', role: ['god'], code: 'BM:LIST'
                }
            },

        ]
    },
    {
        path: '/channelShop',
        component: Layout,
        name: 'channelShop',
        hidden: false,
        redirect: 'channelShop/index',
        meta: { title: '渠道管理', icon: 'iconqudaojieru', role: ['god'], code: 'BM' },
        children: [
            {
                path: 'index',
                name: 'channelShopIndex',
                component: channelShopIndex,
                hidden: false,
                meta: {
                    title: '渠道列表', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'addChannelShop',
                name: 'addChannelShopIndex',
                component: addChannelShopIndex,
                hidden: true,
                meta: {
                    title: '新增渠道商', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'channelMoney',
                name: 'channelShopMoney',
                component: channelShopMoney,
                hidden: false,
                meta: {
                    title: '渠道资金', icon: 'iconzijinmingxi', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'addChannelMoney',
                name: 'channelShopAddMoney',
                component: channelShopAddMoney,
                hidden: true,
                meta: {
                    title: '渠道资金充值', icon: 'icon-ceshi', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'channelAccount',
                name: 'channelAccountIndex',
                component: channelAccount,
                hidden: false,
                meta: {
                    title: '渠道账户', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'policy-ticket',
                name: 'policyTicketIndex',
                component: policyTicketIndex,
                hidden: true,
                meta: {
                    title: '机票差标', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'policy-hotel',
                name: 'policyHotelIndex',
                component: policyHotelIndex,
                hidden: true,
                meta: {
                    title: '酒店差标', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'policy-hotel-control',
                name: 'policyHotelControlIndex',
                component: hotelControl,
                hidden: true,
                meta: {
                    title: '酒店管控', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'policy-train',
                name: 'policyTrainIndex',
                component: policyTrainIndex,
                hidden: true,
                meta: {
                    title: '火车差标', icon: 'iconliebiao', role: ['god'], code: 'BM:LIST'
                }
            },

        ]
    },
    {
        path: '/user',
        component: Layout,
        name: 'account',
        hidden: false,
        redirect: 'user/index',
        meta: { title: '账户管理', icon: 'iconaccount', role: ['god'], code: 'BM' },
        children: [
            {
                path: 'index',
                name: 'accountIndex',
                component: accountIndex,
                hidden: false,
                meta: {
                    title: '账户列表', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            }
        ]
    },
    {
        path: '/order',
        component: Layout,
        name: 'order',
        hidden: false,
        redirect: 'order/index',
        meta: { title: '订单管理', icon: 'icondingdanguanli', role: ['god'], code: 'BM' },
        children: [

            {
                path: 'exchange',
                name: 'exchange',
                component: exchange,
                hidden: false,
                meta: {
                    title: '东航积分', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'scoreQuery',
                name: 'scoreQuery',
                component: scoreQuery,
                hidden: false,
                meta: {
                    title: '积分用户查询', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'offLineTicket',
                name: 'offLineTicket',
                component: offLineTicket,
                hidden: false,
                meta: {
                    title: '线下票台', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'ticketStatusList',
                name: 'ticketStatusList',
                component: ticketStatusList,
                hidden: false,
                meta: {
                    title: '车票状态', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'index',
                name: 'orderIndex',
                component: orderIndex,
                hidden: false,
                meta: {
                    title: '订单列表', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'detail',
                name: 'orderDetail',
                component: orderDetail,
                hidden: true,
                meta: {
                    title: '订单详情', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'supply',
                name: 'supplyIndex',
                component: supplyList,
                hidden: false,
                meta: {
                    title: '供应订单', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'refundOrder',
                name: 'refundOrderIndex',
                component: refundOrderList,
                hidden: false,
                meta: {
                    title: '退票订单', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'refundDetail',
                name: 'refundDetailIndex',
                component: refundDetailIndex,
                hidden: true,
                meta: {
                    title: '退票订单详情', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'supplyDetail',
                name: 'supplyDetailIndex',
                component: supplyDetailIndex,
                hidden: true,
                meta: {
                    title: '供应订单详情', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: "planeOrder",
                name: "panleOrder",
                component: planeOrder,
                hidden: false,
                meta: {
                    title: '行程单', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'planeDetail',
                name: "planeDetail",
                component: planeDetail,
                hidden: true,
                meta: {
                    title: '机票订单详情', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            //行程单打印
            {
                path: 'orderPaint/:id/:taskcode',
                name: "orderPaint",
                component: orderPaint,
                hidden: true,
                meta: {
                    title: '行程单打印详情', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            },
            //酒店订单
            {
                path: 'hotelOrder',
                name: "hotelOrder",
                component: hotelOrder,
                hidden: true,
                meta: {
                    title: '酒店订单', icon: 'icondingdanliebiao', role: ['god'], code: 'BM:LIST'
                }
            }
        ]
    },
    {
        path: '/insurance',
        component: Layout,
        name: 'insurance',
        hidden: false,
        redirect: 'insurance/index',
        meta: { title: '保险管理', icon: 'iconaccount', role: ['god'], code: 'BM' },
        children: [
            {
                path: 'index',
                name: 'insuranceIndex',
                component: insuranceIndex,
                hidden: false,
                meta: {
                    title: '保险列表', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            }
        ]
    },
    {
        path: '/financial',
        component: Layout,
        name: 'financial',
        hidden: false,
        redirect: 'financial/channelFinancial',
        meta: { title: '财务管理', icon: 'iconaccount', role: ['god'], code: 'BM' },
        children: [
            {
                path: 'electronicChannelFinancial',
                name: 'electronicChannelFinancial',
                component: electronicChannelFinancial,
                hidden: false,
                meta: {
                    title: '电子票渠道结算', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'electronicChannelDetail',
                name: 'electronicChannelDetail',
                component: electronicChannelDetail,
                hidden: true,
                meta: {
                    title: '电子票渠道结算单明细', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'channelFinancial',
                name: 'channelFinancial',
                component: channelFinancial,
                hidden: false,
                meta: {
                    title: '渠道结算', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'channelFinancialDetail',
                name: 'channelFinancialDetail',
                component: channelFinancialDetail,
                hidden: true,
                meta: {
                    title: '渠道结算单明细', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'supplyFinancial',
                name: 'supplyFinancial',
                component: supplyFinancial,
                hidden: false,
                meta: {
                    title: '供应对账', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            },
            {
                path: 'supplyFinancialDetail',
                name: 'supplyFinancialDetail',
                component: supplyFinancialDetail,
                hidden: true,
                meta: {
                    title: '供应对账单明细', icon: 'iconzhanghu', role: ['god'], code: 'BM:LIST'
                }
            }
        ]
    },
    {
        path: '/sys',
        component: Layout,
        name: 'sys',
        hidden: false,
        redirect: 'sys/index',
        meta: { title: '系统配置', icon: 'icongoodsppesupplier', role: ['god'], code: 'BM' },
        children: [
            {
                path: 'index',
                name: 'userIndex',
                component: userIndex,
                hidden: false,
                meta: {
                    title: '用户列表', icon: 'iconzhanghu', role: ['god'], code: 'SYS:USER:LIST'
                }
            },
            {
                path: 'index',
                name: 'roleIndex',
                component: roleIndex,
                hidden: false,
                meta: {
                    title: '角色列表', icon: 'iconzhanghu', role: ['god'], code: 'SYS:ROLE:LIST'
                }
            },
            {
                path: 'index',
                name: 'menuIndex',
                component: menuIndex,
                hidden: false,
                meta: {
                    title: '菜单列表', icon: 'iconzhanghu', role: ['god'], code: 'SYS:MENU:LIST'
                }
            },
            {
                path: 'index',
                name: 'deptIndex',
                component: deptIndex,
                hidden: false,
                meta: {
                    title: '部门列表', icon: 'iconzhanghu', role: ['god'], code: 'SYS:DEPT:LIST'
                }
            },
        ]
    },
    {
        path: '/404',
        component: () => import(/* webpackChunkName: "404" */ '../views/404.vue'),
        hidden: true
    },
    { path: '/:pathMatch(.*)*', redirect: '/404', hidden: true },

];

let router = createRouter({
    history: createWebHistory("/train-admin/"),
    routes: routerArr,
});

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem("token");
    if (to.name != "login") {
        if (!token) {
            message.error("请重新登陆");
            router.replace({
                name: "login",
            });
        } else {
            next();
        }
    } else {
        next();
    }
});

export { routerArr, router };
